import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    padding: 15,
    paddingBottom: 10,
  },
  title: {
    fontSize: theme.typography.fontSize - 2,
    color: theme.palette.text.secondary,
    display: (useStylesParams) => useStylesParams.large === false && 'none',
  },
  value: {
    fontSize: (useStylesParams) =>
      useStylesParams.large
        ? theme.typography.fontSize + 14
        : theme.typography.fontSize,

    fontWeight: theme.typography.fontWeightBold,
    color: (useStylesParams) =>
      useStylesParams.status
        ? theme.palette.metrics[useStylesParams.status]
        : theme.palette.text.primary,
  },
  goal: {
    fontSize: theme.typography.fontSize - 2,
    lineHeight: '1.2em',
    color: theme.palette.hover4,
  },
  metrics: {
    display: 'flex',
    flexDirection: (useStylesParams) =>
      useStylesParams.large ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 0,
    gap: '0.5em',
  },
}))

export default useStyles
